// Features/Zendesk-Chat/mod.ts
var Selector_Toggle = `[ data-action = toggle-chat ]`;
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(Selector_Toggle).forEach((button) => {
    button.addEventListener("click", () => {
      if (typeof window.zE === "function")
        window.zE("messenger", "open");
    });
  });
});
